import React from "react";
import "./NextSection.css";

export default function NextSection() {
  return (
    <section className="next-section">
      <div className="next-container">
        <div className="next-left">
          <h2 className="next-title">Let’s engineer what’s next</h2>
          <p className="next-subtitle">
            A conversation today. Lasting impact tomorrow
          </p>
        </div>

        <div className="next-right">
          <a href="/contact">
            <button className="next-btn">
            Start a Conversation <span className="arrow">→</span>
          </button></a>
        
        </div>
      </div>
    </section>
  );
}